// Copyright (C) 2019 TANNER AG

import React from "react";
import * as PropTypes from "prop-types";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core"
import { HeaderItem } from "./item";
import { withStore } from "../../store/withstore";
import { withRouter } from "react-router-dom";

const styles = {
	wrapper: {
		width: "100%",
		display: "block",
		height: "80px",
		boxShadow: "0 3px 3px 0 rgba(48,60,73,0.15)",
		backgroundColor: "#F0F1F2",
		marginBottom: "30px"
	},
	progressWrapper: {
		width: "100%",
		height: 3
	},
	progress: {
		display: "block",
		backgroundColor: "#e40045",
		height: "100%",
		width: "50%",
		transition: "margin 1s 0.3s"
	},
	separator: {
		position: "absolute",
		top: 0,
		left: "50%",
		width: "1px",
		backgroundColor: "rgba(48,60,73,0.15)",
		height: "80px",
		"&:before": {
			content: '"VS"',
			position: 'absolute',
			height: 40,
			width: 40,
			top: "50%",
			transform: "translate(-50%, -50%)",
			boxShadow: "0 0 5px 0 #E2E3E4",
			backgroundColor: '#fff',
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			fontSize: 12,
			color: "#9DA3A9",
			fontFamily: 'MAN-light, Arial, sans-serif'
		}
	},
	itemWrapper: {
		position: "relative",
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		height: "100%"
	}
};

const Header = (props) => {
	const { classes, store: { a, b }, onItemClick } = props;
	return (
		<div className={classes.wrapper}>
			<div className={classes.itemWrapper}>
				<HeaderItem
					number={1}
					name={a.bus.name}
					doors={a.bus.doors}
					fuel={a.bus.fuel}
					type={a.bus.type}
					onClick={() => onItemClick(0)}
				/>
				<HeaderItem
					number={2}
					name={b.bus.name}
					doors={b.bus.doors}
					fuel={b.bus.fuel}
					type={b.bus.type}
					disabled={Boolean(!props.index && !b.bus.id)}
					onClick={() => onItemClick(1)}
				/>
				<div className={classes.separator}/>
			</div>
			<div className={classes.progressWrapper}>
				<span
					className={classes.progress}
					style={{ marginLeft: (props.index) ? "50%" : "0" }}
				/>
			</div>
		</div>
	);
};

Header.propTypes = {
	store: PropTypes.object,
	history: PropTypes.object,
	index: PropTypes.number,
	onItemClick: PropTypes.func
};

Header.defaultProps = {
	index: 0
};

export default compose(
	withRouter,
	withStore,
	withStyles(styles)
)(Header);



// WEBPACK FOOTER //
// ./src/tco/entry/header/index.js